import useLoad from 'components/hooks/useLoad';
import {shift} from 'constants/url';

function useLoadTurn() {
  return useLoad(shift, 'iD_Shift', {});
}

export default useLoadTurn;
